function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

import React, { PureComponent, Children, cloneElement } from 'react';
import Viewer from './viewer';
var RViewerTriggerName = Symbol('RViewerTriggerName');

var isRViewerTrigger = function isRViewerTrigger(el) {
  return el.type && el.type.componentName == RViewerTriggerName;
};

function deepMap(children, callback) {
  return Children.map(children, function (child) {
    if (child === null) return null;

    if (isRViewerTrigger(child)) {
      return callback(child);
    }

    if (child.props && child.props.children && _typeof(child.props.children) === 'object') {
      return cloneElement(child, _extends(_extends({}, child.props), {
        children: deepMap(child.props.children, callback)
      }));
    }

    return child;
  });
}

var PreviewTrigger = /*#__PURE__*/function (_PureComponent) {
  _inherits(PreviewTrigger, _PureComponent);

  function PreviewTrigger() {
    _classCallCheck(this, PreviewTrigger);

    return _possibleConstructorReturn(this, _getPrototypeOf(PreviewTrigger).apply(this, arguments));
  }

  _createClass(PreviewTrigger, [{
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return PreviewTrigger;
}(PureComponent);

PreviewTrigger.componentName = RViewerTriggerName;

var Preview = /*#__PURE__*/function (_PureComponent2) {
  _inherits(Preview, _PureComponent2);

  function Preview(props) {
    var _this;

    _classCallCheck(this, Preview);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Preview).call(this, props));

    _this.show = function () {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      _this.setState({
        isShow: true,
        index: index
      });
    };

    _this.hide = function () {
      _this.setState({
        isShow: false
      });
    };

    _this.state = {
      isShow: false,
      index: 0
    };
    return _this;
  }

  _createClass(Preview, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          imageUrls = _this$props.imageUrls,
          options = _this$props.options;
      var resultUrls = typeof imageUrls === 'string' ? [imageUrls] : imageUrls;
      return React.createElement(React.Fragment, null, this.state.isShow && React.createElement(Viewer, {
        imageUrls: resultUrls,
        index: this.state.index,
        options: options,
        hide: this.hide
      }), deepMap(children, function (child) {
        var props = {
          onClick: function onClick() {
            var index = child.props.index;

            _this2.show(index);
          }
        };
        return cloneElement(child.props.children, props);
      }));
    }
  }]);

  return Preview;
}(PureComponent);

Preview.Trigger = PreviewTrigger;
export default Preview;